<template>
  <div id="settings">
    <h1 class="maintitle">Configuration</h1>

    <div class="my-3">
      <ClassicButton
        label="Nouvelle feuille"
        classButton="button primaryButton w-full text-lg"
        @buttonClick="
          initSetting();
          showModal = true;
        "
      />
    </div>

    <div  class="flex flex-wrap"   v-if="list_settings && list_settings.length > 0" >
      <ClassicButton
        v-for="(item, index) of list_settings"
        :key="index"
        :label="item.name"
        classButton="button secondaryButton big-button w-full"
        @buttonClick="
          showModal = true;
          selectSetting(index);
        "
      />
    </div>

    <Modal
      :showModal="showModal"
      @hideModal="
        showModal = false;
        index = null;
        sortSettings();
      "
    >
      <template v-slot:modalHeader>
        <button
          @click.prevent="showModal = !showModal"
          type="button"
          title="fermer"
          class="modal-header modal-gray"
        >
          &times;
        </button>
      </template>

      <template v-slot:modalBody>
        <div class="modal-body container mx-auto">
          <div class="flex">
            <button
              type="button"
              class="modal-close"
              @click.prevent="showModal = false"
            >
              &times;
            </button>
          </div>

          <div class="p-2" @submit.prevent="">
            <div class="formFlexPrimary">
              <div class="flex-grow">
                <input
                  id="settingTitle"
                  type="text"
                  class="input-text text-xl"
                  v-model="settings.name"
                  placeholder="Titre (ex: Five Tribes)"
                />
              </div>

              <div>
                <button
                  v-if="edit"
                  class="trashButton"
                  @click.prevent="
                    removeSetting(index);
                    showModal = false;
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    class="svg size-6"
                  >
                    <path
                      d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class=" p-2 flex-col">
            <div
              class="formFlexSecondary"
              v-for="(line, index) of settings.scoresheet"
              :key="index"
            >
              <div class="flex-grow">
                <input
                  type="text"
                  name="color"
                  class=" input-text "
                  v-model="line.label"
                  placeholder="Nom"
                />
              </div>

              <div class="block ml-auto ">
                <button
                  class=" trashButton "
                  @click.prevent="deleteScoresheetLine(index)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    class="svg size-6"
                  >
                    <path
                      d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div class="my-8">
              <FormScoreLine @newLine="addScoresheetline($event)" />
            </div>
          </div>

          <div class="flex ">
            <ClassicButton
              label="Enregistrer"
              classButton="button primaryButton text-lg w-full"
              :disabled="settings.name == '' || !settings.scoresheet"
              @buttonClick="
                showModal = false;
                if (!edit) {
                  addSettings();
                }
              "
            />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import FormScoreLine from "@/components/ui/form/FormScoreLine.vue";
import Modal from "@/components/ui/generic/Modal.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";

export default {
  name: "settings",
  data() {
    return {
      edit: false,
      index: null,
      showModal: false,
      settings: {
        name: "",
        scoresheet: [],
        rounds: 0,
        details: []
      },
      list_settings: []
    };
  },
  components: {
    FormScoreLine,
    Modal,
    ClassicButton
  },
  methods: {
    initSetting() {
      this.settings = {
        name: "",
        scoresheet: [],
        rounds: 0,
        details: []
      };
      this.index = null;
      this.edit = false;
    },
    addScoresheetline(event) {
      this.settings.scoresheet.push(event);
    },
    deleteScoresheetLine(index) {
      this.settings.scoresheet.splice(index, 1);
    },
    sortSettings() {
      //console.info('sortSettings');
      this.list_settings.sort(function(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    updateSettings() {
      this.list_settings[this.index] = this.settings;
      this.index = null;
      //this.sortSettings();
    },
    addSettings() {
      this.list_settings.push(this.settings);
      this.edit = false;
    },
    selectSetting(index) {
      this.settings = this.list_settings[index];
      this.index = index;
      this.edit = true;
      //this.list_settings.splice(index, 1);
    },
    removeSetting(index) {
      this.list_settings.splice(index, 1);
      this.index = null;
    }
  },
  mounted() {
    //console.info("Page des réglages");
    if (localStorage.getItem("skor_settings")) {
      //this.settings = JSON.parse(localStorage.getItem("skor_settings"));
    }
    if (localStorage.getItem("skor_list_settings")) {
      this.list_settings = JSON.parse(
        localStorage.getItem("skor_list_settings")
      );
    }
  },
  watch: {
    settings: {
      handler() {
        // console.info("Réglages modifiés");
        //localStorage.setItem("skor_settings", JSON.stringify(this.settings));
      },
      deep: true
    },
    list_settings: {
      handler() {
        //console.info("Réglages complets modifiés");

        localStorage.setItem(
          "skor_list_settings",
          JSON.stringify(this.list_settings)
        );
      },
      deep: true
    }
  }
};
</script>